import { twinAppThemeResponseSchema } from "../workspace-preferences.js";
import { defineOperation } from "./http.js";
export const TWIN_APP_THEME_OPERATIONS = {
    getAppTheme: defineOperation({
        operationId: "twin.app-theme.get", method: "GET", path: "/api/twin/app-theme",
        audience: "public", requiredScope: "twin.read", rateClass: "read", request: {},
        response: { kind: "json", status: 200, schema: twinAppThemeResponseSchema },
        sdk: { namespace: "twin", method: "getTwinAppTheme" }, swiftSdk: { method: "getTwinAppTheme" },
        openapi: {
            summary: "Get the person's app theme",
            description: "The theme the signed-in person chose in this organisation, for a native client that draws its own colours to match the app's pages. Null until they save one; \"system\" and null both mean the app's default theme.",
            responseDescription: "The person's saved theme in this organisation", errors: [401, 403],
        },
    }),
};
